import React, { useState } from 'react';
import PageContainer from 'src/components/container/PageContainer';
import DashboardCard2 from 'src/components/shared/DashboardCard2';
import {
  Box,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  Pagination,
  IconButton,
} from '@mui/material';
import ClearIcon from '@mui/icons-material/Close';
import RefreshIcon from '@mui/icons-material/Refresh';
import SearchImg from '../../../assets/search.svg';
import FieldData from './FieldData';

const ClientCampaign = () => {
  const [search, setSearch] = useState('');
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(20);
  const [refreshTrigger, setRefreshTrigger] = useState(0);
  const [pagination, setPagination] = useState({
    page: 1,
    limit: 20,
    totalCampaigns: 0,
    totalPages: 1,
  });

  const handleLimitChange = (e) => {
    setLimit(Number(e.target.value));
    setPage(1);
  };

  const handleSearchChange = (e) => {
    setSearch(e.target.value);
    setPage(1);
  };

  const handleClearSearch = () => {
    setSearch('');
    setPage(1);
  };

  const handlePageChange = (event, newPage) => {
    setPage(newPage);
  };

  const handleRefresh = () => {
    setRefreshTrigger((prev) => prev + 1);
  };

  return (
    <PageContainer title="Client WhatsApp Campaigns" description="This contains all WhatsApp campaigns sent to clients">
      <DashboardCard2 title="Client Campaigns">
        {/* Top Controls: Show per page & Search */}
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'flex-end',
            marginBottom: '1.7rem',
            flexWrap: 'wrap',
            gap: '1rem',
          }}
        >
          {/* Left side - Show per page */}
          <div>
            <InputLabel>Show per page</InputLabel>
            <Select
              style={{
                borderRadius: '7px',
                border: '0.5px solid #6174DD',
                padding: '4px 12px',
                background: '#FFF',
                height: '40px',
                width: '100px',
              }}
              value={limit}
              onChange={handleLimitChange}
            >
              <MenuItem value={10}>10</MenuItem>
              <MenuItem value={20}>20</MenuItem>
              <MenuItem value={50}>50</MenuItem>
              <MenuItem value={100}>100</MenuItem>
            </Select>
          </div>

          {/* Right side - Search and Refresh */}
          <div
            style={{
              display: 'flex',
              alignItems: 'flex-end',
              gap: '0.5rem',
            }}
          >
            {/* Search Box */}
            <div style={{ width: '220px' }}>
              <InputLabel>Search</InputLabel>
              <div
                className="search-input"
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  border: '0.5px solid #6174DD',
                  borderRadius: '7px',
                  padding: '4px 12px',
                  background: '#FFF',
                  height: '40px',
                  minWidth: '220px',
                  cursor: 'pointer',
                }}
                onClick={() => document.getElementById('campaign-search-input')?.focus()}
              >
                <img src={SearchImg} alt="Search" style={{ marginRight: '8px' }} />
                <input
                  id="campaign-search-input"
                  type="text"
                  placeholder="Search Campaigns..."
                  value={search}
                  onChange={handleSearchChange}
                  style={{
                    flex: 1,
                    border: 'none',
                    outline: 'none',
                    background: 'transparent',
                    marginLeft: '0.5rem',
                  }}
                />
                {search && (
                  <IconButton onClick={handleClearSearch} style={{ padding: 1 }}>
                    <ClearIcon
                      style={{
                        color: '#000',
                        marginRight: '-0.2rem',
                        marginTop: '0.1rem',
                        fontSize: '1.1rem',
                      }}
                    />
                  </IconButton>
                )}
              </div>
            </div>

            
          </div>
        </div>

        {/* Campaign Table View */}
        <Box>
          <Grid container spacing={3}>
            <Grid item xs={12} lg={12}>
              <FieldData
                search={search}
                page={page}
                limit={limit}
                refreshTrigger={refreshTrigger}
                onPaginationChange={setPagination}
              />
            </Grid>
          </Grid>
        </Box>

        {/* Pagination */}
        <Box display={'flex'} justifyContent={'flex-end'} mt={3}>
          <Pagination
            count={pagination.totalPages || 1}
            page={pagination.page || page}
            color="primary"
            onChange={handlePageChange}
            disabled={!pagination.totalCampaigns || pagination.totalPages <= 1}
          />
        </Box>
      </DashboardCard2>
    </PageContainer>
  );
};

export default ClientCampaign;

